"use strict";

import {initAjaxFormMap as initAjaxFormMapGoogle} from "@elements/ajax-form-map/ajax-form-google";
import { findAll, findIn, on, trigger, closest, addClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import fetch from "@elements/fetch"
import {showNotification} from "@elements/alert-notification";
import {translate} from '@elements/translations';
import {loadGoogleMapsAPI} from "@elements/google-map";

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    function getGooglePoiStyles(){
        return {
            currentPosition: {
                default: {
                    url: '/static/img/pois/infrastructure.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/infrastructure.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            infrastructure: {
                default: {
                    url: '/static/img/pois/infrastructure.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/infrastructure.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            gastronomy: {
                default: {
                    url: '/static/img/pois/gastronomy.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/gastronomy.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            sightseeing: {
                default: {
                    url: '/static/img/pois/sightseeing.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/sightseeing.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            traffic: {
                default: {
                    url: '/static/img/pois/traffic.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/traffic.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            wellness: {
                default: {
                    url: '/static/img/pois/wellness.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/wellness.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            },
            bike: {
                default: {
                    url: '/static/img/pois/bike.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                },
                active: {
                    url: '/static/img/pois/bike.svg',
                    size: new google.maps.Size(72, 83),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(27, 37)
                }
            }
        };
    }

    function getGoogleInfoBoxOptions(){
        let width = isMobile() ? "300px" : "600px";
        let offsetX = isMobile() ? -150 : -158;
        let offsetY = isMobile() ? -22 : -50;

        return {
            pixelOffset: new google.maps.Size(offsetX, offsetY),
            boxStyle: {width: width, padding: "0"},
            boxClass: "info-box",
            closeBoxURL: "/static/img/close.svg"
        };
    }

    function onActivateMarker(marker, api) {
        // api.showInfoBoxByMarker(marker, '<div>test</div>');

        if(marker.detailInfoBoxUrl) {
            let infoBoxPromise = api.showInfoBoxByMarker(
                marker,
                ` <div class="loading-spinner" aria-label="loading...">
                    <div class="loading-spinner__item loading-spinner__item--1"></div>
                    <div class="loading-spinner__item loading-spinner__item--2"></div>
                    <div class="loading-spinner__item loading-spinner__item--3"></div>
                </div>`
            );

            let contentPromise = fetch(marker.detailInfoBoxUrl, {
                method: 'GET',
                headers: {"content-type": "application/json"}
            }).then((res) => {
                return res.json()
            });


            Promise.all([infoBoxPromise, contentPromise]).then(([infoBox, response]) => {
                infoBox.setContent(response.html);
            });
        }

    }

    function onDeactivateMarker(marker, api) {
        api.closeInfoBoxByMarker(marker);

    }

    findAll('.js-ajax-form-map-google').map(googleMap => {

        let lng = findIn('.js-ajax-form-map-google__location-lng', googleMap);
        let lat = findIn('.js-ajax-form-map-google__location-lat', googleMap);
        let addressInput = findIn('.js-ajax-form-map-google__search-input', googleMap);
        let mapObj = findIn('.js-ajax-form-map-google__map__canvas', googleMap);
        let initialLat = +googleMap.getAttribute('data-google-map-initial-lat') || 47.2183939;
        let initialLng = +googleMap.getAttribute('data-google-map-initial-lng') || 14.306775;
        let initialZoom = +googleMap.getAttribute('data-google-map-initial-zoom') || 10;

        on('focusout', function(event) {
            event.preventDefault();
            getGeoCodeFromAddress(addressInput.value, mapObj, googleMap, lat, lng);
        }, addressInput);

        on('keydown', function(event) {
            if(event.key == 'Enter') {
                event.preventDefault();
                getGeoCodeFromAddress(addressInput.value, mapObj, googleMap, lat, lng);
            }
        }, addressInput);

        onFind('.js-ajax-form-map-google__get-geo-location', function (element) {
            on('click', function(event) {
                event.preventDefault();
                getLocation(mapObj, googleMap, lat, lng, true);
            }, element);
        });

        let clusteringOptions = {
            default: {
                styles: [{
                    height: 46,
                    url: "/img/marker-cluster.svg",
                    width: 46,
                    textSize: 20,
                    textColor: "#FFF"
                }]
            },
            active: {
                styles: [{
                    height: 46,
                    url: "/img/marker-cluster.svg",
                    width: 46,
                    textSize: 20,
                    textColor: "#FFF"
                }]
            }
        };

        let selectors = {
            result: '.js-ajax-form-map-google__result',
            loading: '.js-ajax-form-map-google__loading',
            notifications: '.js-ajax-form-map-google__notifications',
            form: '.js-ajax-form-map-google__form',
            additionalForm: '.js-ajax-form-map-google__additional-form',
            errorArea: '.js-ajax-form-map-google__error-area',
            retry: '.js-ajax-form-map-google__retry',
            link: '.js-ajax-form-map-google__link',
            reset: '.js-ajax-form-map-google__reset',
        };

        let map = initAjaxFormMapGoogle(googleMap, {
            element: findIn('.js-ajax-form-map-google__map__canvas', googleMap),
            poiStyles: () => getGooglePoiStyles(),
            infoBoxOptions: () => getGoogleInfoBoxOptions(),
            clustering: false,
            clusteringOptions,
            onActivateMarker: (marker, api) => onActivateMarker(marker, api),
            onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
            mapOptions: {
                center: {lat: initialLat, lng: initialLng},
                zoom: initialZoom,
                scrollwheel: true,
                mapTypeControl: false,
                streetViewControl: false,
                style: [
                    {
                        "featureType": "administrative.locality",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ]
            }
        }, selectors);

        loadGoogleMapsAPI().then(() => {
            on('input', function(evt) {
                let requestMin = 3;
                if(evt.target.value.length < requestMin){
                    return;
                }else{
                    const autocomplete = new google.maps.places.Autocomplete(addressInput,
                        { types: ["geocode"],
                            offset: 4,
                            componentRestrictions: {'country': ['at']},
                            fields: ['formatted_address'] }
                    );
                    autocomplete.addListener("place_changed", addCustomerLocation);
                }
            }, addressInput);

            function addCustomerLocation(evt, _) {
                let form = findIn('.js-ajax-form-map-google__form', googleMap);
                trigger('submit', form);
            }
        });
    })
}

function getGeoCodeFromAddress(addressValue, mapObj, container, lat, lng){
    let geocoder = new google.maps.Geocoder();
    let searchInput = findIn('.js-ajax-form-map-google__search-input', container);

    geocoder.geocode({'address': addressValue}, (results, status) => {
        if (status === "OK") {
            if (results[0]) {
                searchInput.value = results[0].formatted_address;
                let latVal =  results[0].geometry.location.lat();
                let lngVal = results[0].geometry.location.lng();
                lat.value = latVal;
                lng.value = lngVal;
                
                addClass('has-value', closest('.form-group', searchInput));

                // let searchPoi = [{lat: latVal, lng: lngVal, poiStyle: 'currentPosition'}];
                // mapObj.googleMap.addMarker(searchPoi);
                // let myLatLng = {lat: latVal, lng: lngVal};
                // let searchMarker = new google.maps.Marker({
                //     position: myLatLng
                // });
                //
                // mapObj.googleMap.getMapInstance().setZoom(12);
                // mapObj.googleMap.getMapInstance().panTo(searchMarker.position);

            } else {
                console.log("Geocoding: No results found");
            }
        } else {
            console.log("Geocoder failed due to: " + status);
        }
    });
}

function getLocation(mapObj, container, lat, lng, submitTrigger) {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            

            if (latitude && longitude) {
                let pos = {
                    lat: latitude,
                    lng: longitude
                };
                
                // change text in search field
                let searchInput = findIn('.js-ajax-form-map-google__search-input', container);
                let geocoder = new google.maps.Geocoder();

                geocoder.geocode({location: pos}, (results, status) => {
                    if (status === "OK") {
                        if (results[0]) {
                            searchInput.value = results[0].formatted_address;
                            lat.value = latitude;
                            lng.value = longitude;
                            addClass('has-value', closest('.form-group', searchInput));
                        } else {
                            console.log("Geocoding: No results found");
                        }
                    } else {
                        console.log("Geocoder failed due to: " + status);
                    }
                });

                if(submitTrigger) {
                    // submit form
                    let form = findIn('.js-ajax-form-map-google__form', container);
                    trigger('submit', form);
                }

            }
        }, function (e) {
            showNotification({
                type: 'danger',
                title: translate('interactiveMap.errors.no-location.title'),
                content: translate('interactiveMap.errors.no-location.message'),
                closable: true
            });
        });
    } else {
        // the browser doesn't support geolocation
        showNotification({
            type: 'danger',
            title: translate('interactiveMap.errors.not-supported.title'),
            content: translate('interactiveMap.errors.not-supported.message'),
            closable: true
        });
    }
}

